import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getRecipientWiresPath = () => urlHelper('/recipient/wires');
